import { call, select, fork, take, cancel, put } from 'redux-saga/effects';
import { bindAsyncAction } from '../../utils/sagas';
import { apiRequest } from '../../utils/api';

import { login } from '../auth/actions';
import { logoutButtonClick } from '../../components/Auth/actions';
import { fetchDevices } from '../devices/actions';
import { activateGeozone, createGeozone, deleteGeozone, loadGeozones, updateGeozone, updateGeozoneFinished } from './actions';
import { switchCurrentDevice } from '../../components/Modal/actions';
import {
  activateGeozoneClicked, createGeozoneClicked, deleteGeozoneClicked,
  updateGeozoneClicked,
} from '../../components/Modal/GeozonesModal/actions';
import { changeCurrentDevice } from '../../components/Header/actions';

const weeklyConverter = (payload, days) => {
  const result = {};

  days.forEach((day, index) => {
    if (payload[day]) {
      const { from,  to } =  payload[day];
      if (from < to) {
        result[day] = (result[day] || []).concat(payload[day]);
      } else {
        result[day] = (result[day] || []).concat({from});
        if (index === 6) {
          result[days[0]] = [{from: '00:00:00', to}].concat(result[days[0]] || []);
        } else {
          result[days[index + 1]] = [{from: '00:00:00', to}];
        }
      }
    }
  });
  return result;
};


const worker = bindAsyncAction(loadGeozones, function* getGeozones(params) {
  return yield call(apiRequest, params);
});

const createWorker = bindAsyncAction(createGeozone, function* createGeozoneRequest(params) {
  return yield call(apiRequest, params);
});

const deleteWorker = bindAsyncAction(deleteGeozone, function* deleteGeozones(params) {
  return yield call(apiRequest, params);
});

const activateWorker = bindAsyncAction(activateGeozone, function* activateGeozones(params) {
  return yield call(apiRequest, params);
});

const updateWorker = bindAsyncAction(updateGeozone, function* updateGeozones(params) {
  return yield call(apiRequest, params);
});


function* fetchGeozonesSaga(deviceId) {
  let currentDevice = yield select(state => state.devices.currentDevice.id);
  currentDevice = deviceId || currentDevice;
  const filterParams = {
    deviceIds: [currentDevice],
  };
  console.log(currentDevice);
  try {
    yield call(worker, {
      url: '/api/v2/geozone/filter',
      method: 'POST',
      body: JSON.stringify(filterParams),
    });
  } catch (e) {
    console.log(e);
  }
}

function* createGeozonesSaga() {
  while (true) {
    const { payload } = yield take(createGeozoneClicked.type);
    const deviceId = yield select(store => store.settings.currentDevice.id);

    const weeklyParams = weeklyConverter(payload, ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']);

    const convertedParams = {
      name: payload.name,
      weekly: weeklyParams,
      isEnabled: 'true',
      wkt: payload.wkt,
    };

    try {
      yield call(createWorker, {
        url: `/api/v2/device/${deviceId}/geozone`,
        method: 'POST',
        body: JSON.stringify(convertedParams),
      });
    } catch (e) {
      console.log(e);
    }
  }
}
function* deleteGeozoneSaga() {
  while (true) {
    const { payload } = yield take(deleteGeozoneClicked.type);
    try {
      yield call(deleteWorker, {
        url: `/api/v2/geozone/${payload.id}/remove`,
        method: 'POST',
        GeozoneId: payload.id,
      });
    } catch (e) {
      console.log(e);
    }
  }
}
function* activateGeozoneSaga() {
  while (true) {
    const { payload } = yield take(activateGeozoneClicked.type);
    try {
      yield call(activateWorker, {
        url: `/api/v2/geozone/${payload.geozone.id}/enable`,
        method: 'POST',
        body: JSON.stringify({ on: !payload.geozone.isEnabled }),
        GeozoneId: payload.geozone.id,
      });
    } catch (e) {
      console.log(e);
    }
  }
}

function* updateGeozonesSaga() {
  while (true) {
    const { payload } = yield take(updateGeozoneClicked.type);

    const weeklyParams = weeklyConverter(payload, ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']);

    const convertedParams = {
      name: payload.name,
      intervals: {
        intervals: [{ from: payload.from, to: payload.to }],
      },
      weekly: weeklyParams,
      isEnabled: 'true',
      wkt: payload.wkt,
    };

    try {
      yield call(updateWorker, {
        url: `/api/v2/geozone/${payload.id}/profile`,
        method: 'POST',
        body: JSON.stringify({ name: convertedParams.name }),
      });

      yield call(updateWorker, {
        url: `/api/v2/geozone/${payload.id}/wkt`,
        method: 'POST',
        body: JSON.stringify({ wkt: convertedParams.wkt }),
      });

      yield call(updateWorker, {
        url: `/api/v2/geozone/${payload.id}/schedule/weekly`,
        method: 'POST',
        body: JSON.stringify({ ...convertedParams.weekly }),
      });

      yield put({ type: updateGeozoneFinished.done.type });
      yield call(fetchGeozonesSaga);
    } catch (e) {
      console.log(e);
    }
  }
}

function* getGeozonesSaga() {
  yield fork(fetchGeozonesSaga);
  while (true) {
    const action = yield take([switchCurrentDevice.type, createGeozone.done.type, changeCurrentDevice.type, deleteGeozone.done.type]);
    yield fork(fetchGeozonesSaga, (action.payload.device && action.payload.device.id) || null);
  }
}

export default function* geozonesSaga() {
  while (true) {
    yield take(login.done.type);
    yield take(fetchDevices.done.type);

    const geozonesFetchingSaga = yield fork(getGeozonesSaga);
    const geozonesCreatingSaga = yield fork(createGeozonesSaga);
    const geozonesDeletingSaga = yield fork(deleteGeozoneSaga);
    const geozonesActivatingSaga = yield fork(activateGeozoneSaga);
    const geozonesUpdatingSaga = yield fork(updateGeozonesSaga);

    yield take(logoutButtonClick.type);
    yield cancel(geozonesFetchingSaga);
    yield cancel(geozonesCreatingSaga);
    yield cancel(geozonesDeletingSaga);
    yield cancel(geozonesActivatingSaga);
    yield cancel(geozonesUpdatingSaga);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/geozones/index.js